import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function VisibilityOffIcon(props: FixMe) {
  return <VisibilityOff {...props} />;
}

export default VisibilityOffIcon;
